// frontend/src/pages/EmailVerification.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import api from "../../services/authService";
import { setAuth } from "../../features/authSlice";

const EmailVerification = () => {
  const { token: rawToken } = useParams();
  const token = rawToken ? decodeURIComponent(rawToken) : "";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await api.get(
          `/auth/verify-email/${encodeURIComponent(token)}`
        );
        if (response.data.token && response.data.user) {
          dispatch(
            setAuth({
              token: response.data.token,
              user: response.data.user,
            })
          );
        }
        setStatus("success");
        // Rediriger vers la page d'accueil après 3 secondes
        setTimeout(() => {
          navigate("/home");
        }, 3000);
      } catch (error) {
        console.error("Erreur de vérification:", error);
        setStatus("error");
      }
    };

    verifyEmail();
  }, [token, navigate, dispatch]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {status === "verifying" && "Vérification de votre email..."}
            {status === "success" && "Email vérifié avec succès !"}
            {status === "error" && "Erreur de vérification"}
          </h2>
          <div className="mt-2 text-center text-sm text-gray-600">
            {status === "verifying" && (
              <p>Veuillez patienter pendant la vérification...</p>
            )}
            {status === "success" && (
              <p>
                Votre compte a été vérifié avec succès. Redirection vers la page
                d'accueil...
              </p>
            )}
            {status === "error" && (
              <p>Le lien de vérification est invalide ou a expiré.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
